import { TableTr } from '@/components/ui/data-display/tables/TableTr';
import { Instances } from '../Instances';

export const TableRow = ({ data }) => {
  return (
    <TableTr>
      <Instances instances={data?.relations?.TableCellsList} />
    </TableTr>
  );
};
